export enum PlatformFeaturesKey {
  LEARNING_PATH = 'learningPath',
  WEBINARS = 'webinars',
  CALENDAR = 'calendar',
  IN_PERSON_EVENTS = 'inPersonEvents',
  COMMUNITY = 'community',
  LIBRARY = 'library',
  ACHIEVEMENTS = 'achievements',
  SITEMAP = 'sitemap',
  CERTIFICATES = 'certificates',
  COUPONS = 'coupons',
  CHALLENGES = 'challenges',
  GLOSSARY = 'glossary',
  LEADERBOARD = 'leaderboard',
  CHAT = 'chat',
  MANAGER_VIEW = 'managerView',
  NOTIFICATIONS = 'notifications',
  PROJECT_MANAGEMENT = 'projectManagement',
  AI_CHATBOT = 'aiChatbot',
  AI_LESSON_GENERATION = 'aiLessonGeneration',
  AI_TEXT_IMAGE_GENERATION = 'aiTextImageGeneration',
  MOBILE_APP = 'mobileApp'
}
